module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/babel-loader/lib/index.js?presets[]=env&presets[]=react!../../node_modules/react-markdown-loader/src/index.js!./rules.md"));
	}, "rules");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=rules!./src/content/rules.md
// module id = vqiW
// module chunks = 2